<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import { Link, usePage } from "@inertiajs/vue3";

const locale = computed(() => usePage().props.locale);

// Layout
import PublicLayout from "@/Layouts/PublicLayout.vue";
import AcademieFirst from "@/Components/AcademieFirst.vue";
import AcademieSecond from "@/Components/AcademieSecond.vue";
import AcademieThird from "@/Components/AcademieThird.vue";
import AcademieFourth from "@/Components/AcademieFourth.vue";
import AcademieFifth from "@/Components/AcademieFifth.vue";
import AcademieSix from "@/Components/AcademieSix.vue";
import AcademieSeven from "@/Components/AcademieSeven.vue";
import AcademieEight from "@/Components/AcademieEight.vue";

const { t } = useI18n();

const props = defineProps({
  page: Object,
  jobOffers: Object,
  blogArticles: {
    type: Array,
    required: true
  }
});
</script>

<template>
  <PublicLayout title="Zorgblik">
    <AcademieFirst />
    <AcademieSecond />
    <AcademieThird />
    <AcademieFourth />
    <AcademieFifth />
    <AcademieSix />
    <AcademieSeven />
    <AcademieEight />
  </PublicLayout>
</template>
